import { FinBoxResponse } from "src/shared/services/APIResponse";
import { ExecuteUiConfigRequestDTO } from "src/dtos/UiConfigDTO";
import { Post } from "src/shared/services/Fetch";

export interface IUiConfigService {
  executeUIConfig(
    token: string,
    dto: ExecuteUiConfigRequestDTO,
    isLenderDashboard: boolean
  ): Promise<FinBoxResponse<any>>;
}

export class UiConfigService implements IUiConfigService {
  constructor() {}

  public async executeUIConfig(
    token: string,
    dto: ExecuteUiConfigRequestDTO,
    isLenderDashboard: boolean
  ): Promise<FinBoxResponse<any>> {
    let endpoint = "/masterDashboard/execute-ui-action";
    if (isLenderDashboard) {
      endpoint = "/lender/execute-ui-action";
    }
    return await Post(endpoint, token, dto);
  }
}
